import { ReportNavigationModalComponent } from './report-navigation-modal.component';

export default angular
  .module('sfMobile.components.report-navigation-modal', [
    'sfMobile.services.localization',
    'sfMobile.components.text-see-more',
  ])
  .component('sfReportNavigationModal', ReportNavigationModalComponent).name;
